var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.566897 8.63139L8.63139 0.566897C9.38725 -0.188965 10.6127 -0.188966 11.3686 0.566896L19.4331 8.63139C20.189 9.38725 20.189 10.6127 19.4331 11.3686L11.3686 19.4331C10.6127 20.189 9.38725 20.189 8.63139 19.4331L0.566897 11.3686C-0.188966 10.6127 -0.188966 9.38725 0.566897 8.63139ZM9.61379 2.40761L2.40769 9.61372C2.18255 9.83885 2.18226 10.2036 2.40704 10.4284L9.60174 17.6231C9.82652 17.8478 10.1913 17.8475 10.4164 17.6224L17.6225 10.4163C17.8476 10.1912 17.8479 9.82645 17.6231 9.60167L10.4284 2.40697C10.2037 2.18219 9.83893 2.18248 9.61379 2.40761ZM9.99901 4.02699C10.3299 4.02699 10.6026 4.27605 10.6398 4.59692L10.6442 4.67216V11.9979C10.6442 12.3543 10.3553 12.6431 9.99901 12.6431C9.66814 12.6431 9.39545 12.3941 9.35818 12.0732L9.35384 11.9979V4.67216C9.35384 4.31585 9.64269 4.02699 9.99901 4.02699ZM9.99901 13.6837C9.45879 13.6837 9.02085 14.1216 9.02085 14.6618C9.02085 15.2021 9.45879 15.64 9.99901 15.64C10.5392 15.64 10.9772 15.2021 10.9772 14.6618C10.9772 14.1216 10.5392 13.6837 9.99901 13.6837ZM9.99901 14.3496C10.1714 14.3496 10.3112 14.4894 10.3112 14.6618C10.3112 14.8342 10.1714 14.974 9.99901 14.974C9.82659 14.974 9.68683 14.8342 9.68683 14.6618C9.68683 14.4894 9.82659 14.3496 9.99901 14.3496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAlerts);
export default __webpack_public_path__ + "static/media/activeAlerts.2a95b444db3908bac72079e2fc23b854.svg";
export { ForwardRef as ReactComponent };